/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgFitSize = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="m15.293 16.293 1.414 1.414L14.414 20H19v2H5v-2h4.586l-2.293-2.293 1.414-1.414L12 19.587zM22 5v14h-2v-4.586l-2.293 2.293-1.414-1.414L19.586 12l-3.293-3.293 1.414-1.414L20 9.586V5zM4 5v4.586l2.293-2.293 1.414 1.414L4.414 12l3.293 3.293-1.414 1.414L4 14.414V19H2V5zm15-3v2h-4.586l2.293 2.293-1.414 1.414L12 4.414 8.707 7.707 7.293 6.293 9.586 4H5V2z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgFitSize as FitSize };
